import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "./index.css";
import App from "./App";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { Theme, StyledEngineProvider } from "@mui/material/styles";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

if (import.meta.env.PROD) {
  disableReactDevTools();
}

if (import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    // enabled: !!import.meta.env.VITE_SENTRY_DSN,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing({})],
    release: import.meta.env.VITE_VERSION,
    // sampleRate: 1,
    tracesSampleRate: 0.1,
    autoSessionTracking: false,
    environment: import.meta.env.MODE || "unknown",
    ignoreErrors: [
      /network error/i,
      /ChunkLoadError/i,
      // /e is not a function/i /* when gapi can't be loaded, could be cookies not allowed or domain not on WL */,
      /Nothing was returned from render/i,
    ],
  });
}

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// import { apm } from "@elastic/apm-rum";
// apm.init({
//   active: true,
//   serverUrl: "http://localhost:8200",
//   serviceName: "weepy-frontend",
//   serviceVersion: import.meta.env.VITE_VERSION,
//   environment: import.meta.env.MODE || "unknown",
// });

// import { getSettings } from './services/settings';
// if (getSettings().send_usage_statistics) {
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
